import React, { memo, useMemo } from 'react';
import { Button, Flex, Input } from 'antd';
import { useParams } from 'react-router-dom';
import {
    PlusOutlined,
    AppstoreOutlined,
    BarsOutlined,
} from '@ant-design/icons';

import {
    ProductsFilters,
    ProductsViewType,
} from '../service/products.interface';
import { useManageProducts } from '../hooks/useManageProducts';
import { useUpdateProductsType } from '../../payments/hooks/useUpdateProductsType';
import { useAppSelector } from '../../../../../store';
import { getShopState } from '../../shops/store/shopSlice';
import { TreeCategoryFilter } from '../../categories/components/TreeCategoryFilter';
import { PRODUCTS_VIEW } from '../utils/products';

const CREATE_LABELS: Record<string, string> = {
    'product-order': 'Добавить заявку',
    links: 'Добавить витрину',
};

const SEARCH_PLACEHOLDERS: Record<string, string> = {
    links: 'Поиск по витринам',
    archive: 'Поиск по архиву',
    'product-order': 'Поиск по заявкам',
    products: 'Поиск по товарам',
};

type ProductTabs = {
    readonly updateFilters: (filters: ProductsFilters) => void;
    readonly setViewType: (viewType: ProductsViewType) => void;
    readonly viewType: ProductsViewType;
    readonly filters: ProductsFilters;
};
export const ProductTabs = memo((props: ProductTabs) => {
    const { updateFilters, setViewType, viewType, filters } = props;

    const { id, type } = useParams();
    const { manageProduct } = useManageProducts();
    const { updateAllProductsType } = useUpdateProductsType();
    const { type: shopType } = useAppSelector(getShopState);

    const viewTypeButton = useMemo(() => {
        const isCards = viewType === PRODUCTS_VIEW.cards;
        const Icon = isCards ? BarsOutlined : AppstoreOutlined;
        const nextView = isCards ? PRODUCTS_VIEW.table : PRODUCTS_VIEW.cards;

        return (
            <Button
                style={{ padding: '0px 0.5rem' }}
                onClick={() => setViewType(nextView)}
            >
                <Icon />
            </Button>
        );
    }, [viewType, setViewType]);

    return (
        <Flex justify={'space-between'} wrap={'wrap'} gap={20}>
            <Flex vertical={false} gap={12}>
                <Button
                    disabled={
                        shopType === 1 &&
                        (type === 'products' ||
                            type === 'archive' ||
                            type === 'product-order')
                    }
                    type={'primary'}
                    onClick={() => {
                        manageProduct(type);
                    }}
                >
                    <PlusOutlined /> {CREATE_LABELS[type] ?? 'Добавить товар'}
                </Button>

                <div>
                    <Input
                        value={filters.title}
                        allowClear
                        onChange={e =>
                            updateFilters({ ...filters, title: e.target.value })
                        }
                        placeholder={SEARCH_PLACEHOLDERS[type] ?? 'Поиск'}
                    />
                </div>
            </Flex>

            <Flex gap={12}>
                <TreeCategoryFilter
                    filters={filters}
                    updateFilters={updateFilters}
                />
                {type === 'links' && (
                    <Button
                        disabled={shopType === 1}
                        onClick={() => {
                            updateAllProductsType('product', +id);
                        }}
                    >
                        Перевести витрины в товары
                    </Button>
                )}
                {['products', 'links', 'product-order', 'archive'].includes(
                    type ?? ''
                ) && viewTypeButton}
            </Flex>
        </Flex>
    );
});
